<template>
  <div ref="mescroll" class="mescroll" v-cloak>
    <ul class="shenzhenBox">
      <li v-for="(items,index) in regionDatas" :key="index">
        <p class="sName">{{items.name}}</p>
        <div class="place"><img src="../../../static/img/placeIcon.png" alt=""><p>{{items.address}}</p></div>
        <div class="phone"><img src="../../../static/img/phoneIcon.png" alt=""><p>{{items.phone}}</p></div>
      </li>
    </ul>
    <div class="homeBotTxt">
        <p>Copyright ©2018 思考乐教育</p>
        <div>
          <router-link to="/LegalDeclaration">法律声明</router-link>
          <span class="l">|</span>
          <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}">校区导航</router-link>
        </div>
    </div>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import 'mescroll.js/mescroll.min.css'
import MeScroll from 'mescroll.js'

export default{
  data(){
    return{
      regionDatas: '',
      pageNum: 0,
      pageSize: 10,
      maxPageNum: 2,
      mescroll: null, //mescroll实例对象
      dataList:[] //列表数据
    }
  },
  created(){
    this.axios.get(this.$root.baseUrl+'/wap/home/school?currentPage='+this.pageNum+'&pageSize='+this.pageSize+'&cityId='+this.$route.query.cityId)
    .then(res=>{
      console.log(1111)
      this.regionDatas = res.data.LIST;
      this.maxPageNum = Math.ceil(res.data.PAGE_BEAN.totalNum/this.pageSize)
      console.log(this.maxPageNum)
      console.log(res)
    })
    .catch(e=>{
      console.log(e)
    })
  },
  components: {
    MescrollVue
  },
  mounted(){
      console.log(this.maxPageNum)
    // 创建MeScroll对象:为避免配置的id和父组件id重复,这里使用ref的方式初始化mescroll
      this.mescroll = new MeScroll(this.$refs.mescroll, {// 在mounted生命周期初始化mescroll,以确保您配置的dom元素能够被找到.
        down: {
          auto: true, // 是否在初始化完毕之后自动执行下拉回调callback; 默认true
          callback: this.downCallback // 下拉刷新的回调
        },
        up: {
          auto: false, // 是否在初始化时以上拉加载的方式自动加载第一页数据; 默认false
          callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page) { upCallback(page); }
          page: {
            num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
            size: 10 // 每页数据的数量
          },
          noMoreSize: 5, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
          // toTop: { // 配置回到顶部按钮
          //   src: './static/mescroll/mescroll-totop.png'
          // }
        }
      })
  },
  beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
      next(vm => {
      if (vm.mescroll) {
      // 恢复到之前设置的isBounce状态
      if (vm.mescroll.lastBounce != null) vm.mescroll.setBounce(vm.mescroll.lastBounce)
      // 滚动到之前列表的位置(注意:路由使用keep-alive才生效)
      if (vm.mescroll.lastScrollTop) {
        vm.mescroll.setScrollTop(vm.mescroll.lastScrollTop)
        setTimeout(() => { // 需延时,因为setScrollTop内部会触发onScroll,可能会渐显回到顶部按钮
          vm.mescroll.setTopBtnFadeDuration(0)// 设置回到顶部按钮显示时无渐显动画
        }, 16)
      }
    }
  })
  },
  beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
    if (this.mescroll) {
      this.mescroll.lastBounce = this.mescroll.optUp.isBounce// 记录当前是否禁止ios回弹
      this.mescroll.setBounce(true) // 允许bounce
      this.mescroll.lastScrollTop = this.mescroll.getScrollTop()// 记录当前滚动条的位置
      this.mescroll.hideTopBtn(0)// 隐藏回到顶部按钮,无渐隐动画
    }
    next()
  },
  watch: {
    $route: {
      handler: function(newVal, oldVal){
      console.log(this.maxPageNum)
      this.pageNum = 1;
      this.maxPageNum = 2;
        this.axios.get(this.$root.baseUrl+'/wap/home/school?currentPage='+this.pageNum+'&pageSize='+this.pageSize+'&cityId='+this.$route.query.cityId)
          .then(res=>{
            console.log(res)
            this.newListDatas = res.data.LIST;
            this.maxPageNum = Math.ceil(res.data.PAGE_BEAN.totalNum/this.pageSize)
            console.log(this.maxPageNum)
          })
          .catch(e=>{
            console.log(e)
          })
        },
      deep: true
    }
  },
  methods: {
    //上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page) {
      console.log(22222)
      console.log(this.pageNum)
      console.log(this.maxPageNum)
      if(this.pageNum < this.maxPageNum) this.pageNum++;  
      //联网请求
       this.axios.get(this.$root.baseUrl+'/wap/home/school?currentPage='+this.pageNum+'&pageSize='+this.pageSize+'&cityId='+this.$route.query.cityId)
      .then((response)=> {
        console.log(response)
        //请求的列表数据
        let arr = response.data.LIST;
        //如果是第一页需手动制空列表
        if (this.pageNum == 1) this.regionDatas = [];
        //把请求到的数据添加到列表
        this.regionDatas = this.regionDatas.concat(arr);
        //数据渲染成功后,隐藏下拉刷新的状态
        this.$nextTick(() => {
          this.mescroll.endSuccess(arr.length);
        })
        this.maxPageNum = Math.ceil(res.data.PAGE_BEAN.totalNum/this.pageSize)
      })
      .catch((e)=> {
        //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
        this.mescroll.endErr();
      })
    }
  }
} 

</script>

<style scope>
.mescroll {
    position: fixed;
    top: calc(4.8rem);
    bottom: 0;
    height: auto;
/*    position: relative;
    top: 5rem;*/
}
.mescroll-downwarp {
    position: relative;
    width: 100%;
    height: 0;
    overflow: hidden;
    text-align: center;
    /*top: 3.5rem;*/
}
.shenzhenBox{
    /*margin-top: 2.5rem;*/
    /*margin-top: 5.5rem;*/
/*    display: inline-block;*/
    margin: 0 auto;
    display: block;
} 
.shenzhenBox li{
    padding: 1.3rem 0 1.6rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #f7f8f9;
    margin: 0 1.2rem;
}
.sName{
    font-size: 1.2rem;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center; 
    margin-bottom: 1.6rem;   
}
.sName span{
    background: #ff8800;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 0.8rem;
    padding: 0.2rem 0.5rem;
    /* vertical-align: top; */
    margin-left: 0.6rem;
    line-height: 1rem;
    height: 1.2rem;
    display: inline-block;
    box-sizing: border-box;
}
.shenzhenBox li .place img{
    width: 0.86667rem;
    display: inline-block;
    vertical-align: top;
    margin-top: 0.2rem;
}
.shenzhenBox li .phone img{
    width: 0.8333rem;
    display: inline-block;
    vertical-align: middle;   
}
.place{
    margin-bottom: 1.2rem;
}
.place p{
    display: inline-block;
    vertical-align: top;
    max-width: 20rem;
    margin-left: 1rem;
    font-size: 0.9333rem;
    line-height: 1.4rem;
}
.phone p{
    display: inline-block;
    vertical-align: middle;
    max-width: 20rem;
    margin-left: 1rem;
    font-size: 0.9333rem;
    line-height: 1.2rem;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>


// WEBPACK FOOTER //
// src/components/campus/CampusCon.vue